import axios from "axios";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

const axiosAuthInstance = axios.create({
  baseURL: "https://diner.smartvillageqatar.com/",
  Accept: "application/json",
  "Content-Type": "application/json",
});

const decryptWithAES = (text, passphrase) => {
  const decryptedToken = AES.decrypt(text, passphrase);
  return decryptedToken.toString(Utf8);
};

axiosAuthInstance.interceptors.request.use(function (config) {
  const token = decryptWithAES(sessionStorage.getItem("ut"), "userToken");
  config.baseURL =
    sessionStorage.getItem("branch") === "branch1"
    ? process.env.REACT_APP_BRANCH_1
    : process.env.REACT_APP_BRANCH_2;
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

export default axiosAuthInstance;
